import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks"
import { editAttributes } from "../../../../../services/verifyService/model/verification/VerificationSlice";
import { ReduxUpdate } from "../../../../../utils/ReduxUpdateCommands";
import { Switch } from "@progress/kendo-react-inputs";
import { toggleVobRequestNoteAddModal } from "../../../../../app/slices/VerificationModuleSlice";
import { VobRequestNoteAdd } from "../notes/VobRequestNoteAdd";

function IsVobRequestAttribute(){
    const dispatch = useAppDispatch();
    const verify = useAppSelector((state)=>state.verification.verification);
    
    const handleVobRequestChange = (e: any) => {
        const newValue = e.target.value;
        dispatch(editAttributes(new ReduxUpdate("isVobRequest", newValue)));
        
        // Open the VOB request note modal when switch is turned ON
        if (newValue) {
            dispatch(toggleVobRequestNoteAddModal());
        }
    }
    
    return <React.Fragment>
        <div>
            <label>VOB Request</label><br/>
            <Switch name='isVobRequest' value={verify.verifyAttributes.isVobRequest??false} 
                checked={verify.verifyAttributes.isVobRequest} 
                onChange={handleVobRequestChange}/>
        </div>
        <VobRequestNoteAdd/>
    </React.Fragment>
}
export {IsVobRequestAttribute}
